import styled from 'styled-components'

export const Container = styled.div`
  display: flex;

  color: var(--table-color);

  span {
    margin: 0 0.5rem;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;

    background: transparent;
    border: 0;

    font-size: 1.2rem;
    color: var(--table-color-selected);

    &:disabled {
      color: var(--table-color);
    }
  }
`
